import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

const accountManagerUrl = "https://am.ticketmaster.com/soundersfc/";
const supportPhone = "8776574625";
const supportPhoneDisplay = "(877) 657-4625";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Matches ",
    description: "Select the matches you wish to attend with your group.",
  },
  {
    icon: <TbShirtSport />,
    title: "Login to Account Manager",
    description: (
      <>
        Click Continue and connect to your{" "}
        <Link
          href={accountManagerUrl}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Seattle Sounders FC
        </Link>{" "}
        account using our secure Ticketmaster login.
      </>
    ),
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for your group.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available to be managed in your{" "}
        <Link
          target={"_blank"}
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href={accountManagerUrl}
        >
          Seattle Sounders FC
        </Link>{" "}
        Account Manager within 24 hours. Reach out for any questions at{" "}
        <Link
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href={`tel:${supportPhone}`}
        >
          {supportPhoneDisplay}
        </Link>
        .
      </>
    ),
  },
];

// TODO(marketing): confirm Sounders Groups FAQ copy. Placeholder set below —
// only the 10-ticket minimum is confirmed from the config.
export const faqs = [
  {
    title: "What is a group ticket order?",
    description:
      "Bring your friends, family, coworkers, or classmates to the match. Group orders let you purchase seats together for the matches you choose (subject to availability).",
  },
  {
    title: "What is the minimum number of tickets for a group?",
    description: "A minimum of 10 tickets is required per group order.",
  },
];
